var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form-input",
    _vm._b(
      {
        staticClass: "flex-grow-1 w-100 mr-3",
        attrs: {
          autofocus: "",
          placeholder: _vm.placeHolder,
          debounce: "1000"
        },
        on: {
          change: _vm.handleChange,
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.handleChange.apply(null, arguments)
          }
        },
        model: {
          value: _vm.textSearch,
          callback: function($$v) {
            _vm.textSearch = $$v
          },
          expression: "textSearch"
        }
      },
      "b-form-input",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }